<div class="main flex flex-col gap-(--gap-loose)">
  @if (loadingService.loading()) {
    <div class="flex justify-center p-(--padding-card)">
      <i class="pi pi-spin pi-spinner text-2xl text-(color:--text-secondary)" aria-hidden="true"></i>
    </div>
  }
  <div class="text-h1">{{ 'pages.home.favoriteAssets' | transloco }}</div>
  @if (loadingService.error()) {
    <div class="error-message text-red-500 p-(--padding-card)">
      {{ loadingService.error() }}
    </div>
  } @else {
    @if (assetsFavorite().length > 0) {
      <ces-card-carousel [value]="assetsFavorite()">
        <ng-template let-asset #item>
          <ces-card [clickable]="true" [title]="asset.name" [href]="getAssetHref(asset.id)" (cardClick)="navigate(asset.id)">
            <ng-template #footer>
              <div class="flex flex-row justify-between gap-(--gap-normal) items-center">
                <ces-favorite-button [isFavorite]="asset.isFavorite" (favoriteToggle)="toggleFavorite(asset)" />
              </div>
            </ng-template>
          </ces-card>
        </ng-template>
      </ces-card-carousel>
    } @else if (!loadingService.loading()) {
      <div class="empty-state text-(color:--text-secondary) p-(--padding-card)">{{ 'pages.home.noAssets' | transloco }}</div>
    }
  }
  <div class="text-h1">{{ 'pages.home.recentAssets' | transloco }}</div>
  @if (loadingService.error()) {
    <div class="error-message text-red-500 p-(--padding-card)">
      {{ loadingService.error() }}
    </div>
  } @else {
    @if (assets().length > 0) {
      <ces-card-carousel [value]="assets()">
        <ng-template let-asset #item>
          <ces-card [clickable]="true" [title]="asset.name" [href]="getAssetHref(asset.id)" (cardClick)="navigate(asset.id)">
            <ng-template #footer>
              <div class="flex flex-row justify-between gap-(--gap-normal) items-center">
                <ces-favorite-button [isFavorite]="asset.isFavorite" (favoriteToggle)="toggleFavorite(asset)" />
              </div>
            </ng-template>
          </ces-card>
        </ng-template>
      </ces-card-carousel>
    } @else if (!loadingService.loading()) {
      <div class="empty-state text-(color:--text-secondary) p-(--padding-card)">{{ 'pages.home.noAssets' | transloco }}</div>
    }
  }
</div>
